export default __webpack_public_path__ + "static/media/4_Intro.18d8c4ec.mp4";